import { FarmHeader } from '@/entities/farm/ui/FarmHeader'
import { LimitSection } from '@/entities/farm/ui/LimitSection'
import { TodaysStatsSection } from '@/entities/farm/ui/TodaysStatsSection'
import { BaseCard } from '@/shared/components'
import { Link } from 'react-router-dom'
import { AdminRequisitFarmListPayload } from 'syncra-api-client'

interface FarmWidgetProps {
  data: AdminRequisitFarmListPayload
  openModal: () => void
}

export const FarmWidget = ({ data, openModal }: FarmWidgetProps) => {
  return (
    <Link to={`/farm/${data.farm?.id}`} className="flex">
      <BaseCard variant="secondary" padding="md" className="flex flex-col gap-3 w-full h-full transition-all">
        {/* Header с иконкой, названием, тегами и кнопками */}
        <FarmHeader
          data={data}
          openModal={openModal}
        />

        {/* Обороты */}
        <LimitSection
          dailyLimit={data.farm?.maxDailyLimit ?? 0}
          monthlyLimit={data.farm?.maxMonthlyLimit ?? 0}
          dailyAmountInRub={data.todayTopup?.paidAmountFrom ?? 0}
          monthlyAmountInRub={data.monthlyStatistic?.amountIn}
        />

        {/* Статистика за сегодня */}
        <TodaysStatsSection
          counterInSuccess={data.todayTopup?.paidCount}
          counterIn={data.todayTopup?.totalCount}
          currency={data.farm!.currency!}
          dailyLimit={data.farm?.maxDailyLimit ?? 0}
        />
      </BaseCard>
    </Link>
  )
}
